export const createTitle = (title: string) => `EVIE - ${title}`;
